import { FC } from 'react';
import {
  Form,
  Input,
  FormInstance,
} from 'antd';

import { requiredField } from '../../../../constants/formRules';
import { RichTextEditor } from '../../../RichTextEditor';
import { translit } from '../../../../utils/translit';

type Props = {
  data: any;
  form: FormInstance;
};

export const BlogGeneralTab: FC<Props> = ({ data, form }) => {
  const handleNameChange = ({ target: { value } }: any) => {
    const alias = translit(value);
    form.setFieldsValue({ alias });
  };

  return (
    <>
      <Form.Item
        name="name"
        label="Заголовок*"
        rules={requiredField}
      >
        <Input onChange={handleNameChange} />
      </Form.Item>
      <Form.Item name="alias" label="Url псевдоним*" rules={requiredField}>
        <Input />
      </Form.Item>
      <Form.Item name="introtext" label="Краткое описание">
        <Input maxLength={100} />
      </Form.Item>
      <div>
        <span>Описание</span>
        <Form.Item name="content" label="Контент" noStyle>
          <RichTextEditor initialValue={data.content} />
        </Form.Item>
      </div>
    </>
  );
};